import { Button, Fade, SxProps, Theme, Tooltip } from '@mui/material';

interface IconStatusButtonProps {
  onClick: () => void;
  statusIcon: React.ReactNode;
  statusText: string;
  tooltipContent?: React.ReactNode;
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  dataTestId?: string;
  ariaLabel?: string;
}

function IconStatusButton({
  onClick,
  disabled,
  statusIcon,
  statusText,
  tooltipContent,
  fullWidth,
  sx,
  dataTestId,
  ariaLabel,
}: IconStatusButtonProps): React.ReactElement {
  return (
    <Tooltip title={tooltipContent}>
      <Button
        onClick={onClick}
        fullWidth={fullWidth}
        startIcon={statusIcon}
        disabled={disabled}
        sx={sx}
        data-testid={dataTestId}
        aria-label={ariaLabel}
      >
        <Fade in key={statusText} timeout={300}>
          <span>{statusText}</span>
        </Fade>
      </Button>
    </Tooltip>
  );
}

IconStatusButton.defaultProps = {
  tooltipContent: undefined,
  fullWidth: false,
  sx: {},
  dataTestId: 'icon-status-button',
  ariaLabel: 'Icon Status Button',
  disabled: false,
};

export default IconStatusButton;
